module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('p', {
    staticClass: "i-tit"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bright and bold; soft and subtle; shiny, matte, and everything in between—this book will show you new and exciting ways to use gorgeous fabrics and incredible colors. Whether you are a traditional quilter, art quilter, or modern quilter, there is a method and style for you in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("•  Layers of shapes and colors fool the eye, allowing you to create dynamic quilts using easy construction techniques.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("•  Interactions of color and pattern will delight you.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("•  Three different construction methods can be applied to endless design possibilities.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Throughout this book, you’ll explore options for color, style, scale, and construction. Start with one quilt and you’ll soon be on your way to a series.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After reading this book, you will never look at fabrics the same way again.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2899ec20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introduction.vue
// module id = 69
// module chunks = 0